import { type DialogProps, TextField } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ComparisonObjectValue } from "../../../../services/api/instances/comparisonAPI/types";
import type { DialogValue } from "../../../../services/api/instances/dialogApi/types";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { TransferObjectModal } from "../../../Modals/TransferObjectModal";
import { FolderSelection } from "../../../Modals/TransferObjectModal/Components/FolderSelection";
import { getFilteredOption } from "../../../Modals/TransferObjectModal/helpers";
import { useTransferModal } from "../../../Modals/TransferObjectModal/hooks/use-transfer-modal";
import type { TransferActions } from "../../../Modals/TransferObjectModal/types";
import {
  deleteChildrenAction,
  updateComparisonObjectsWithChildrenAction,
} from "../../redux/actions";
import { selectComparisonObjects } from "../../redux/selectors";
import {
  setComparisonObjects,
  setSelectedComparisonObject,
} from "../../redux/slice";
import styles from "./styles.module.css";
import { StorageObject } from "../../../../services/api/instances/storageApi/types/object_types";

const actions: TransferActions<ComparisonObjectValue> = {
  updateObjectWithChildren: updateComparisonObjectsWithChildrenAction,
  deleteChild: deleteChildrenAction,
  setObjects: setComparisonObjects,
  setSelectedObject: setSelectedComparisonObject,
};

interface Props extends DialogProps {
  closeModal: () => void;
  childId?: string;
}

export const TransferComparisonObjectModal: FC<Props> = ({
  childId,
  closeModal,
  ...props
}) => {
  const comparisonObjects = useAppSelector(selectComparisonObjects);
  const { handleTransfer, targetFolder, objects, handleSelectChange } =
    useTransferModal<ComparisonObjectValue>(comparisonObjects, actions);
  const { t } = useTranslation();
  return (
    <TransferObjectModal
      closeModal={closeModal}
      onClose={closeModal}
      onOk={() => {
        closeModal();
        handleTransfer(childId as string);
      }}
      {...props}
    >
      <div className={styles.container}>
        <FolderSelection
          options={getFilteredOption(objects)}
          value={targetFolder}
          inputValue={targetFolder?.friendly_name}
          getOptionLabel={(option: StorageObject<DialogValue>) =>
            option.friendly_name
          }
          onChange={handleSelectChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={"outlined"}
              placeholder={t("transfer_modal.input_placeholder")}
            />
          )}
        />
      </div>
    </TransferObjectModal>
  );
};
